<template>
  <div class="projectDetails">
    <header-view :tabsign='3'></header-view>
    <div class="body w12 min-h">
		<div class="toptitle">
			<div class="redcon"></div>
			<span>捐款详情</span>
		</div>
		<div class="box">
			<div>捐款人：{{info.donationUserId||''}}</div>
			<div>捐款金额：{{getFormatMoney(info.money)}}</div>
			<div>捐款时间：{{info.donationDate||''}}</div>
			<div style="cursor: pointer;" @click="goProDetail(info.activityId)">关联项目：{{info.activityId?(info.activityTitle||''):('非限定性项目')}}</div>
		</div>
		<div class="sysbox">
			<div v-for="(item,ind) in sysList" :key='ind' class="sys_item" :class="info.fundraisingState-item.value*1>=0?'sys_item_act':''">
				<div>
					<el-image fit='conver' class="sysimg" :src='info.fundraisingState-item.value>=0?redImg:defImg'></el-image>
				</div>
				<div class="tit" v-if='item.value==0'>已捐款</div>
				<div class="tit" v-if='item.value==1'>项目执行中</div>
				<div class="tit" v-if='item.value==2'>项目已完成</div>
			</div>
		</div>
		<!--   -->
		
		<div class="bot" v-if="info.fundraisingState==2">
			<div class="bot-t">
				项目执行报告
			</div>
			<div v-html="info.trackReport" class="msg"></div>
		</div>	
		<div class="f-row-r btnbox" v-if='info.certificateUrl'>
			<div class="btn btn-red f-row-c" @click="downloadbtn">{{isIos?'查看证书':'下载证书'}}</div>
		</div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from '@/utils/util'
export default {
  name: "lovelist_detail",
  data: function() {
    return {
		redImg:require("@/assets/img_red.png"),
		defImg:require("@/assets/img_def.png"),
		info: {},
		query:{},
		sysList:[],
		isIos:false,
    };
  },
  created() {
    this.query = this.$route.query;
	this.isIosFn();
	this.getSys();
	this.getList();
  },
  mounted() {},
  methods: {
	isIosFn(){
      let u = navigator.userAgent
      this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
	downloadbtn(){
      var url= this.getFileAccessHttpUrl(this.info.certificateUrl);
       if(this.isIos){ 
			window.location.href=url
		}else{  
			window.open(url)
		}
    },
	goProDetail(id){
		if(id){ 
			this.$router.push({ path: "/projectDetails?id="+id});
		}else{ 
			this.$router.push({ path: "/publicwelpro"});
		}
	},
	getSys(){//
		this.httpGet("web/dict/getDictItems/fundraising_state").then(res => {
			if(res.success){
				this.sysList = res.result;
			} 
		});
	},
    getList() {
      var that = this;
      this.httpGet("web/donation/thpDonationRecord/donationDetail", {
        recordId: this.query.id
      }).then(res => {
		if(res.success){
			that.info = res.result;
		} 
      });
	  
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;
	  
    },
	getFormatMoney(money){
		return formatMoney(money,0)
	},
  }
};
</script>
<style scoped lang="scss">

.projectDetails {
  width: 100%;
  position: relative;
  .f-row-c{
	display: flex;
	align-items: center;
	justify-content: center;
	}
	.f-row-r{
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
  .btnbox{
	  width: 100%;
	  margin:10px 0px;
	  
	  .btn,.btn-red{
		margin: 0px 10px;
		width: 168px;
		height: 36px;
		background: #E6E6E6;
		color: #333333;
		font-size: 16px;
	}
	.btn-red{
		background: #E61E26;
		color: #ffffff;
		margin-right: 200px;
	}
  }
  
  .body {
    background: #ffffff;
    margin: 120px auto 0;
    overflow: hidden;
	font-weight: 400;
    color: #666666;
	font-size: 16px;
	.toptitle{
		display: flex;
		align-items: center;
		font-size: 25px;
		font-weight: 400;
		color: #E61F26;
		height: 60px;
		.redcon{
			width: 5px;
			height: 20px;
			background: #E70012;
			margin-right: 20px;
		}
	}
    .box {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		div{
			margin-right: 50px;
		}
    }
	.sysbox{ 
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 69px;
		margin-bottom: 89px;
		
		.sys_item,.sys_item_act{
			min-width: 369px;
			position: relative;
			text-align: right;
			.tit{
				position: absolute;
				right: -10px;
				bottom:-30px;
				z-index: 2;
			}
		}
		.sys_item::after,.sys_item_act::after{
			content: '';
			position: absolute;
			left: 15px;
			top: calc(50% - 10px);
			z-index: 10;
			width: calc(100% - 80px);
			height: 1px;
			border-bottom: 2px dashed #CCCCCC;
		}
		.sys_item_act{
			color: #E50112;
		}
		.sys_item_act::after{ 
			border-bottom: 2px dashed #E50112;
		}
		.sys_item:first-child{
			min-width: 54px;
			border-bottom: 0px;
			.tit{ 
				right: 3px;
			}
		}
		.sysimg{ 
			width: 54px;
			height: 52px;
		}
	}

	.bot{ 
		font-size: 24px;
		padding-bottom: 30px;
		font-size: 14px;
		color: #666666;
		.bot-t{
			padding-bottom: 5px;border-bottom: 2px solid #E50112;
			margin-bottom: 20px;
			font-size: 25px;
			font-weight: 400;
			color: #E61F26;
		}
	}
	.msg {
      margin: 0 auto;
    }
  }
  
}
</style>
